import styled from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const Header = styled.header`
    h1 {
        margin: 0;
    }
`;

export const Tags = styled.span`
    display: inline-block;
    font-size: ${rem(21)};
    color: ${colors.lightText};
    margin-bottom: 0.2em;
`;

export const SectionHeading = styled(Heading)`
    ${media.tabletSmall`
      margin-bottom: 0.5em;
    `};
`;

export const DocsList = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 0;
`;

export const DocHeadingItem = styled.li`
    margin-bottom: 1.5em;
`;

export const DocItem = styled.li`
    margin-bottom: 1em;

    & + ${DocHeadingItem} {
      margin-top: 2em;
    }

    small {
      display: inline-block;
    }

    a {
      font-size: ${em(24)};
      line-height: ${32 / 24};
    }

    small {
      font-size: ${em(15)};
      color: ${colors.lightText};
    }

    ${media.tabletSmall`
      svg {
        width: 50px;
        height: 70px;
      }
    `};

    @media print {
      a {
        font-size: ${em(18)};
        line-height: ${24 / 18};
      }
    }
`;

export const StyledPiezimes = styled.footer`
    ${media.tabletSmall`
      margin-top: 2em;
    `};
`;



// WEBPACK FOOTER //
// ./src/pages/Dokumenti/styled.js